import type { ChangelogEntry } from "../types";

/**
 * En faktura som var gjort opp av en kreditnota, sto som Betalt fordi
 * saldoen i PowerOffice var null. Nå vises den som Kreditert.
 */
export const KREDITERT_FAKTURA_2026_10: ChangelogEntry = {
  id: "2026-10-26-kreditert-faktura",
  date: "2026-10-26",
  title: "Krediterte fakturaer vises som Kreditert, ikke Betalt",
  summary: "Fakturaer som er gjort opp av en kreditnota, har fått egen status på Faktura-siden.",
  sections: [
    {
      heading: "Fakturering",
      minRole: "admin",
      items: [
        {
          title: "Kreditert i stedet for Betalt",
          kind: "rettet",
          body: "En faktura som var kreditert fullt ut, sto som Betalt, fordi saldoen i PowerOffice var null. Nå vises den som Kreditert, og du kan filtrere på det. Hold over merket for å se når den ble gjort opp. Omsetningstallene endres ikke.",
        },
      ],
    },
  ],
};
